<template lang="pug" src="./complete-dialog.pug"> </template>
<style lang="scss" src="./complete-dialog.scss" scoped> </style>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    computed: {
        completeDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        closeCompleteDialog() {
            this.completeDialog = false;
        },

        completePhotoReport() {
            this.$store.dispatch('photoReports/completePhotoReport', this.$route.params.id);
            this.closeCompleteDialog();
        }
    }
};
</script>
